import React, { Component } from 'react'
import { Button, Input, Select, Tooltip } from 'antd'
import { inject, observer } from 'mobx-react'
import { commissions } from '@services/api'
import { alertPopup } from '@utils/popup'
import { toLiteralMonth, missingMsg } from '../../utils'
import RateComp from '../RateComp'
import MathExpr, { op } from '../MathExpr'
import SubscriptionOptionLabel from '../SubscriptionOptionLabel'
import { historySubs } from '../historySubs'

@inject((store: any) => {
    const { authStore, popupStore, subscriptionsStore } = store

    return {
        authStore,
        popupStore,
        subscriptionsStore
    }
})
@observer
export default class CreditForm extends Component<any> {
    constructor(props) {
        super(props)
        this.state = {
            inValid: false,
            selectedClient: {},
            numerator: 3,
            monthlyRate: 0,
            advancedRate: 0,
            // subscriptionList: [],
            activeCreditCommission: false,
            noSubOrClient: false,
            subscriptionsToDisplay: []
        }
    }

    componentDidMount() {
        const {
            info: { agentInfo }
        } = this.props
        this.setState({ numerator: agentInfo.advanced_commission })
        this.setRates()
        this.setSubscription()
    }

    componentDidUpdate(prevProps) {
        const {
            info: { oldMethod, agentInfo, subscription }
        } = this.props
        if (prevProps.info.subscription !== subscription) {
            if (subscription.specialSub) {
                this.setNumerator(12)
            }
            this.setRates()
            this.forceUpdate()
        } else if (prevProps.info.oldMethod != oldMethod) {
            if (oldMethod) this.setState({ numerator: 12 })
            else this.setState({ numerator: agentInfo.advanced_commission })
        }
    }

    // setSubscription = () => {

    //     const { info: { recentClientSubscriptions, clientCommissions }, selectSubscription } = this.props

    //     let noSubOrClient =
    //         Array.isArray(recentClientSubscriptions) &&
    //         !recentClientSubscriptions.find(({ subscription_status }) => subscription_status === 'ACTIVE')

    //     let activeCreditCommission
    //     let notEligibleSubs = {}
    //     let subscriptionsToDisplay = []
    //     let done = {}

    //     if (clientCommissions) {
    //         // match each commission to user_subscription
    //         clientCommissions.commissions.forEach(({
    //             user_subscription_id,
    //             status,
    //             balance
    //         }) => {
    //             if (status == 'ACTIVE' && balance == 'CREDIT') {
    //                 recentClientSubscriptions.find((sub) => {
    //                     const {
    //                         user_subscription_id: userSubId,
    //                         subscription_status,
    //                         id
    //                     } = sub

    //                     if (userSubId == user_subscription_id && subscription_status == 'ACTIVE') {
    //                         notEligibleSubs[id] = true
    //                     }
    //                 })
    //             }
    //         })

    //         recentClientSubscriptions.forEach((sub) => {
    //             if (!notEligibleSubs[sub.id]) {
    //                 if (!done[sub.id]) {
    //                     subscriptionsToDisplay.push(sub)
    //                     done[sub.id] = true
    //                 }
    //             }
    //         } )

    //         if (Object.keys(notEligibleSubs).length === recentClientSubscriptions.length) {
    //             activeCreditCommission = true
    //         }

    //         if (subscriptionsToDisplay.length) {
    //             selectSubscription(subscriptionsToDisplay[0].id)
    //         }

    //         this.setState({
    //             activeCreditCommission,
    //             noSubOrClient,
    //             subscriptionsToDisplay
    //         })

    //     }
    // }

    setSubscription = () => {
        const {
            info: { recentClientSubscriptions, clientCommissions, selectedClient },
            selectSubscription
        } = this.props

        // use the subscription saved on the selected client's history
        let matchedSubs = historySubs(selectedClient, recentClientSubscriptions)
        let noSubOrClient = !matchedSubs.length

        let activeCreditCommission
        let notEligibleSubs = {}
        let subscriptionsToDisplay = []

        if (matchedSubs.length && clientCommissions) {
            // match each commission to user_subscription
            matchedSubs.forEach(sub => {
                if (sub.subscription_status != 'ACTIVE') notEligibleSubs[sub.user_subscription_id] = true
                else {
                    let commissionFound = clientCommissions.commissions.find(
                        ({ status, user_subscription_id, balance }) =>
                            status == 'ACTIVE' &&
                            balance == 'CREDIT' &&
                            user_subscription_id == sub.user_subscription_id
                    )

                    if (commissionFound) {
                        notEligibleSubs[sub.user_subscription_id] = true
                    }
                }
            })

            matchedSubs.forEach(sub => {
                if (!notEligibleSubs[sub.user_subscription_id]) {
                    subscriptionsToDisplay.push(sub)
                }
            })

            if (Object.keys(notEligibleSubs).length === matchedSubs.length) {
                activeCreditCommission = true
            }

            if (subscriptionsToDisplay.length) {
                selectSubscription(subscriptionsToDisplay[0].select_id)
            }

            this.setState({
                activeCreditCommission,
                noSubOrClient,
                subscriptionsToDisplay
            })
        }
    }

    setNumerator = numerator => {
        this.setState({ numerator })
    }

    // setSubscriptionList = () => {
    //     const { info: { recentClientSubscriptions } } = this.props
    //     const { subscriptionsStore: { subscriptions: subscriptionsFromStore } } = this.props
    //     let done = {}
    //     let subscriptionList = []

    //     recentClientSubscriptions.forEach(({ id }) => {
    //         let found = subscriptionsFromStore.find((sub) => sub.id == id)
    //         if (found) {
    //             subscriptionList.push(found)
    //             done[found.id] = true
    //         }
    //     });

    //     subscriptionsFromStore.forEach((sub) => {
    //         if (!done[sub.id]) {
    //             subscriptionList.push(sub)
    //             done[sub.id] = true // not realy necessary
    //         }
    //     });

    //     this.setState({ subscriptionList })
    // }

    setRates = () => {
        const { agentType, clientSubscription, percents, productName } = this.props.info
        let monthlyRate = 0
        let advancedRate = 0
        if (productName) {
            // why ?

            let old = null
            if (percents[productName].older_than) {
                if (
                    new Date(clientSubscription.paid_at).getTime() <
                    new Date(percents[productName].older_than).getTime()
                ) {
                    old = true
                }
            }
            monthlyRate = percents[productName][agentType][old ? 'old' : 'monthly']
            advancedRate = percents[productName][agentType][old ? 'old' : 'advanced']

            this.setState({ monthlyRate, advancedRate })
        }
    }

    handleRateInput = (e, type) => {
        let { value } = e.target
        // let type = id.split('_')[0]

        // value = value.replace(/[^0-9.]*((\d*\.?\d{0,2})).*/g, '$2')
        value = value.replace(/[^0-9.]*((\d*\.?\d{0,9})).*/g, '$2')

        this.setState({ [type]: value })
    }

    submit = e => {
        e.preventDefault()

        const {
            info: { agentInfo, selectedClient, oldMethod, subscription },
            info
        } = this.props

        const { numerator, monthlyRate, advancedRate } = this.state

        let missing = []

        let payload = {
            agent_id: agentInfo.id,
            client_id: selectedClient.client_id,
            balance: 'CREDIT',
            numerator,
            amount: '',
            old_method: oldMethod,
            current_percent: numerator == 0 ? monthlyRate : advancedRate,
            advanced_months: subscription.specialSub ? null : agentInfo.advanced_commission,
            one_time: subscription.specialSub ? 1 : 0,
            subscription_id: subscription.id,
            user_subscription_id: subscription.user_subscription_id
        }

        let nodeNames = {
            INPUT: 'INPUT'
        }

        let fields = {
            clientAmount: 'amount'
        }

        for (let el in e.target.elements) {
            let target = e.target.elements[el]

            if (nodeNames[target.nodeName] && target.id.includes('input')) {
                let field = fields[target.id.split('-')[1]]
                if (field) {
                    payload[field] = target.value

                    if (!target.value) {
                        missing.push('סכום')
                        target.style.border = 'solid red 1px'
                    } else {
                        target.style.border = 'solid #d9d9d9 1px'
                    }
                }
            }
        }

        if (missing.length) {
            const msg = missingMsg(missing)
            alertPopup({ type: 'error', title: msg, body: '' })
            return
        }

        commissions
            .createNewCommission(payload)
            .then(res => {
                this.props.getAgentCommissions()
                this.props.getAgentCommissionTotals()

                this.props.resetFormData()

                const body = <Button onClick={this.mentorCommissionPopup}>{'ליצירת עמלת מנטור'}</Button>
                alertPopup({ type: 'success', title: 'עמלה נוצרה בהצלחה', body })

                // this.props.popupStore.togglePopup('mentorCreditCommission', {
                //     agentInfo,
                //     agentCommission: res.data,
                //     clientAgentInfo: info
                // })
            })
            .catch(err => {
                console.log(err)
                alertPopup({ type: 'error', title: 'הפעולה נכשלה', body: '' })
            })
    }

    mentorCommissionPopup = () => {
        const { info } = this.props
        this.props.popupStore.togglePopup('mentorCreditCommission', {
            agentInfo: info.agentInfo,
            clientAgentInfo: info
        })
    }

    render() {
        const {
            info: {
                credit,
                clientAmount,
                subscription,
                // clientSubscription,
                // commissionRate,
                // agentAmount,
                // clientCommissions,
                agentInfo,
                oldMethod,
                // monthlyRate,
                // advancedRate,
                // agentType,
                // percents,
                // productName,
                recentClientSubscriptions
            },
            handleFormInput,
            selectSubscription
        } = this.props

        const {
            numerator,
            monthlyRate,
            advancedRate,
            activeCreditCommission,
            noSubOrClient,
            subscriptionsToDisplay
        } = this.state

        const specialSub = subscription.specialSub

        let date = new Date()
        let firstPayment = clientAmount * advancedRate * (oldMethod ? 12 : agentInfo.advanced_commission)
        let monthlyPayment = clientAmount * monthlyRate
        let currentYear = date.getFullYear()
        let monthlyFrom = date.getMonth() + 1 + numerator
        if (monthlyFrom > 12) {
            monthlyFrom = monthlyFrom - 12
            currentYear++
        }
        monthlyFrom = `${toLiteralMonth(monthlyFrom)} ${currentYear}`

        return (
            <form onSubmit={this.submit} style={{ ...style.column, ...style.form }}>
                {!noSubOrClient && !activeCreditCommission && (
                    <>
                        <div style={{ ...style.formLine }}>
                            <span>מינוי:</span>
                            {recentClientSubscriptions && recentClientSubscriptions.length == 1 ? (
                                <div style={{ width: '60%', display: 'flex' }}>
                                    {/* <span>{`${subscription.name || ""}`}</span> */}
                                    <span>{`${recentClientSubscriptions[0].name || ''}`}</span>
                                </div>
                            ) : (
                                <Select
                                    className="commission-select"
                                    dropdownClassName="commission-dropdown"
                                    value={subscription && subscription.select_id}
                                    // value={subscriptionsToDisplay[0].id}
                                    onChange={selectSubscription}
                                    style={{ width: '70%' }}
                                    dropdownMatchSelectWidth={false}
                                >
                                    {subscriptionsToDisplay.map(
                                        (
                                            {
                                                id,
                                                select_id,
                                                name,
                                                specialSub,
                                                user_subscription_id,
                                                dates_range,
                                                subscription_status,
                                                paid_at
                                            },
                                            idx
                                        ) => {
                                            const format = str => {
                                                return new Date(str).toLocaleDateString('he-IL').replace(/\./g, '/')
                                            }

                                            let start, end
                                            if (dates_range) {
                                                let parsed = JSON.parse(dates_range || '{}')
                                                start = format(parsed.start)
                                                end = format(parsed.end)
                                            }

                                            return (
                                                <Select.Option
                                                    value={select_id}
                                                    style={{ paddingInline: '8px' }}
                                                    title={name}
                                                    key={idx.toString()}
                                                >
                                                    <SubscriptionOptionLabel
                                                        name={name}
                                                        subscription_status={subscription_status}
                                                        paid_at={paid_at}
                                                        extra={specialSub ? (
                                                            <span style={{ whiteSpace: 'nowrap', color: '#888', fontSize: '12px' }}>
                                                                {start} - {end}
                                                            </span>
                                                        ) : null}
                                                    />
                                                </Select.Option>
                                            )
                                        }
                                    )}
                                </Select>
                            )}
                        </div>

                        <div style={{ ...style.formLine }}>
                            <span>{`מחיר מינוי (חודשי)`}</span>
                            <Input
                                value={clientAmount}
                                id="input-clientAmount"
                                onChange={handleFormInput}
                                style={{ ...style.inputStyle }}
                            />
                        </div>

                        {specialSub ? (
                            <Tooltip
                                title={
                                    <MathExpr
                                        tokens={[
                                            { value: clientAmount },
                                            op('×'),
                                            { value: advancedRate }
                                        ]}
                                    />
                                }
                            >
                                <div style={{ ...style.formLine }}>
                                    <>
                                        <span>{`עמלת סוכן`}</span>
                                        <div style={{ width: '60%', display: 'flex' }}>
                                            <input
                                                id="input-agentAmount"
                                                disabled
                                                value={(clientAmount * advancedRate).toFixed(1).replace(/\.?0*$/, '')}
                                                style={{ border: 'none', background: 'none' }}
                                            />
                                        </div>
                                    </>
                                </div>
                            </Tooltip>
                        ) : agentInfo.monthly_commission ? (
                            <Tooltip
                                title={
                                    <MathExpr
                                        tokens={[
                                            { value: clientAmount },
                                            op('×'),
                                            { value: monthlyRate }
                                        ]}
                                    />
                                }
                            >
                                <div style={{ ...style.formLine }}>
                                    <span>{`עמלת סוכן (חודשי בלבד)`}</span>
                                    <div style={{ width: '60%', display: 'flex' }}>
                                        <input
                                            id="input-agentAmount"
                                            disabled
                                            value={(clientAmount * monthlyRate).toFixed(1).replace(/\.?0*$/, '')}
                                            style={{ border: 'none', background: 'none' }}
                                        />
                                    </div>
                                </div>
                            </Tooltip>
                        ) : (
                            <div style={{ ...style.formLine }}>
                                <span>{'עמלת סוכן'}</span>
                                <div style={{ ...style.column, width: '295px' }}>
                                    <Tooltip
                                        title={
                                            <MathExpr
                                                tokens={[
                                                    { value: clientAmount },
                                                    op('×'),
                                                    { value: advancedRate },
                                                    op('×'),
                                                    { value: oldMethod ? 12 : agentInfo.advanced_commission }
                                                ]}
                                            />
                                        }
                                    >
                                        <span>{`${oldMethod ? 'עמלה משונתת' : 'עמלה ראשונית'}: ${firstPayment
                                            .toFixed(1)
                                            .replace(/\.?0*$/, '')}`}</span>
                                        <RateComp
                                            type={'advancedRate'}
                                            disabled={numerator == 0}
                                            handle={e => this.handleRateInput(e, 'advancedRate')}
                                            rate={advancedRate}
                                        />
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            <MathExpr
                                                tokens={[
                                                    { value: clientAmount },
                                                    op('×'),
                                                    { value: monthlyRate }
                                                ]}
                                            />
                                        }
                                    >
                                        <span>{`עמלה חודשית: ${monthlyPayment
                                            .toFixed(1)
                                            .replace(/\.?0*$/, '')} (החל מ${monthlyFrom})`}</span>
                                        <RateComp
                                            type={'monthlyRate'}
                                            disabled={numerator != 0}
                                            handle={e => this.handleRateInput(e, 'monthlyRate')}
                                            rate={monthlyRate}
                                        />
                                    </Tooltip>
                                </div>
                            </div>
                        )}

                        {credit && (
                            <div style={{ ...style.formLine }}>
                                <span>{'נומרטור'}</span>
                                <Select
                                    className="commission-select"
                                    dropdownClassName="commission-dropdown"
                                    defaultValue={oldMethod || specialSub ? 12 : agentInfo.advanced_commission}
                                    onChange={this.setNumerator}
                                    style={{ width: '60%' }}
                                    value={numerator}
                                >
                                    {new Array(oldMethod || specialSub ? 13 : agentInfo.advanced_commission + 1)
                                        .fill(null)
                                        .map((_, index) => {
                                            return (
                                                <Select.Option
                                                    key={index.toString()}
                                                    style={{ paddingRight: '0' }}
                                                    value={index}
                                                >
                                                    {index}
                                                </Select.Option>
                                            )
                                        })}
                                </Select>
                            </div>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button style={{ ...style.button }}>{'אישור'}</button>
                        </div>
                    </>
                )}
                {noSubOrClient && (
                    <span style={{ alignSelf: 'center' }}>{'לא נבחר לקוח / ללקוח שנבחר אין מינוי פעיל'}</span>
                )}
                {activeCreditCommission && <h6 style={{ alignSelf: 'center' }}>{'קיים זיכוי פעיל עבור לקוח זה'}</h6>}
            </form>
        )
    }
}

const style = {
    column: { display: 'flex', flexDirection: 'column' },
    form: { width: '100%', margin: '0  0 30px 0' },
    formLine: { display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '15px' },
    inputStyle: { width: '60%' },
    button: {
        height: '34px',
        width: '64px',
        background: 'white',
        borderRadius: '4px',
        border: 'solid #d9d9d9 1px',
        cursor: 'pointer',
        margin: '0 10px'
    }
}
